import { Base } from '@studiometa/js-toolkit';
import ProductStickyAddToCart from './ProductStickyAddToCart.js';
import Gallery from './Gallery.js';
import ZoomedGallery from './ZoomedGallery/index.js';
import Buybox from './Buybox.js';
import FollowCursor from './FollowCursor.js';

/**
 * Product Component
 *
 */
export default class Product extends Base {
  static config = {
    name: 'Product',
    components: {
      Gallery,
      ZoomedGallery,
      Buybox,
      ProductStickyAddToCart,
      FollowCursor,
    },
  };
}
